module.exports = "pegasus/assets/email1-arrow.png";